// src/App.js
import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CustomThemeProvider from './ThemeContext';
import DashboardLayoutAccount from './layout/DashboardLayoutAccount';

import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PublicFormPage from './pages/PublicFormPage'

export default function App() {
  const role = useSelector((state) => state.auth.user?.roleName);
  return (
    <CustomThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* auth lives outside the dashboard shell */}
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/publicformpage" element={<PublicFormPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* everything else goes through the Dashboard */}
          <Route path="/*" element={role?<DashboardLayoutAccount />: <Navigate to="/signin" replace/>} />
        </Routes>
      </BrowserRouter>
    </CustomThemeProvider>
  );
}